/*
 * Hint: Eventually used later by UI, use their desired values here
 */
export const LayoutTriggers = {
	Card: 'Card',
	Router: 'Router',
	FavoritesDetailView: 'FavoritesDetailView',
	NewMeasurementView: 'NewMeasurementView',
	ProgramSummary: 'ProgramSummary',
	OffCanvas: 'OffCanvas',
	Overlay: 'Overlay',
	Tutorial: 'Tutorial',
	Onboarding: 'Onboarding',
	Unknown: 'Unknown',
};

export type LayoutTriggerKeyType = keyof typeof LayoutTriggers;
export type LayoutTriggerValueType = any;
